import { makeAutoObservable, runInAction } from "mobx"
import {taxAuthBillingApi} from "../api/taxAuthBilling.js";

export class TaxAuthBillingStore {
    payoutEnabled = true;
    constructor() {
        makeAutoObservable(this);
    }

    async checkPayoutsEnabled() {
        const result = await taxAuthBillingApi.checkPayoutEnabled();
        runInAction(() => {
            this.payoutEnabled = result.payoutEnabled;
        });
    }
}

